import { useAuth } from '@/auth/AuthContext';
import { getTokenInfo, setOpenUrl, setTokenInfo } from '@/auth/authUtil';
import { ACCESS_TOKEN } from '@/config';
import { getVersionsUsage, sendShareEmail, validateToken } from '@/pages/login/api';
import { setActiveUrl, setAppConfig, setUser, setVersionUsage } from '@/redux/reducer';
import { RootState } from '@/typings';
import { ElButton, ElMessage, ElMessageBox, isEmpty, useClassNames } from '@qsxy/element-plus-react';
import { useMount } from 'ahooks';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Aside from './Aside';
import Header from './Header';
// import { QRCodeCanvas } from 'qrcode.react';
// import clipboardCopy from 'clipboard-copy';

const Layout = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const themeName = useSelector((state: RootState) => state.themeName);
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});
	const appConfig = useSelector<RootState, RootState['appConfig']>(state => state.appConfig ?? {});

	const { isAuth } = useAuth();
	const location = useLocation();

	const { b, is } = useClassNames('layout', 'ttn');

	// const onCopy = useCallback(() => {
	// 	const res = clipboardCopy((appConfig['share.url.prefix'] ?? '') + '?from=' + loginUser.username);

	// 	res.then(() => {
	// 		ElMessage.success({
	// 			message: '链接复制成功！',
	// 		});
	// 	}).catch(() => {
	// 		ElMessage.error({
	// 			message: '该浏览器不支持自动复制！',
	// 		});
	// 	});
	// }, [appConfig, loginUser.username]);

	// const sessionTimeout = useCallback(
	// 	evt => {
	// 		if (evt.key === STORAGE.LGN_STATUS.value) {
	// 			if (evt.oldValue === 'Y' && isEmpty(evt.newValue)) {
	// 				ElMessageBox.alert('您已退出，请重新登录', '温馨提示', { type: 'warning', showClose: false }).then(() => {
	// 					// 清理登灵状态、菜单等信息
	// 					clearUserInfo();
	// 					dispatch(setActiveIndex(null));
	// 					dispatch(setActiveUrl(null));
	// 					dispatch(setUser(null));
	// 					generateFinger();
	// 					Cookies.remove(ACCESS_TOKEN);
	// 					navigate('/login');
	// 				});
	// 			} else if (evt.newValue === 'Y' && isEmpty(evt.oldValue)) {
	// 				window.location.reload();
	// 			}
	// 		}
	// 	},
	// 	[dispatch, generateFinger, navigate],
	// );

	const initSystem = useCallback(() => {
		const menuId = location.pathname.substring(1);
		dispatch(setActiveUrl(menuId));
		if (isAuth()) {
			if (location.pathname === '/') {
				navigate('/chat');
				return;
			}
			setOpenUrl(location.pathname);
		} else {
			// // 清理登灵状态、菜单等信息
			// clearUserInfo();
			// dispatch(setActiveIndex(null));
			// dispatch(setActiveUrl(null));
			// dispatch(setUser(null));
			// generateFinger();
			// Cookies.remove(ACCESS_TOKEN);
		}
	}, [dispatch, isAuth, location.pathname, navigate]);

	const initApp = useCallback(() => {
		const ele = document.getElementById('loading');
		if (ele) {
			ele.parentNode.removeChild(ele);
		}
		if (isAuth()) {
			if (isEmpty(getTokenInfo())) {
				setTokenInfo(Cookies.get(ACCESS_TOKEN));
			}
			validateToken().then(({ user, data }) => {
				dispatch(setUser(user));
				dispatch(setAppConfig(data));
				getVersionsUsage({ user: user.id }).then(res => {
					dispatch(setVersionUsage({ ...res }));
				});
				initSystem();
			});
		}
	}, [dispatch, initSystem, isAuth]);

	useEffect(() => {
		document.body.className = classNames('app', `theme-${themeName}`, b`sidebar-collapse`);
		initSystem();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [themeName, location.pathname]);

	// useEffect(() => {
	// 	window.addEventListener('storage', evt => sessionTimeout(evt));
	// 	return window.removeEventListener('storage', evt => sessionTimeout(evt));
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	useMount(initApp);

	if (location.pathname === '/') {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return (
		<>
			<section className={classNames(b`container`, `theme-${themeName}`, b`sidebar-collapse`, is('vertical'))}>
				<Header />
				<section className={b`container`}>
					<Aside />
					<main className={b`main`}>
						<Outlet />
					</main>
				</section>
			</section>
		</>
	);
};

export default Layout;
